<script>
import { dataListConfig } from "@/components/base/conf";
import noData from "@/components/base/noData";
import { debounce } from "lodash";
import { findData } from "@/utils/common";

export default {
  name: "dataList",
  components: {
    noData
  },
  props: {
    //数据
    data: {
      type: Array,
      default: () => []
    },
    //api
    api: {
      type: Function,
      default: null
    },
    //参数
    params: {
      type: Object,
      default: () => ({})
    },
    //是否自动运行
    autoLoad: {
      type: Boolean,
      default: true
    },
    //请求数据类型
    dataType: {
      type: String,
      default: ""
    },
    //页码参数
    pageField: {
      type: String,
      default: dataListConfig.pageField
    },
    //数据来源
    dataField: {
      type: String,
      default: dataListConfig.dataField
    },
    //每页数量 参数
    sizeField: {
      type: String,
      default: dataListConfig.sizeField
    },
    //页码参数来源
    totalField: {
      type: String,
      default: dataListConfig.totalField
    },
    //loading的key值
    isLoadingKey: {
      type: String,
      default: dataListConfig.isLoadingKey
    },
    //页码参数起始数
    pageStartIndex: {
      type: [Number, String],
      default: dataListConfig.pageStartIndex
    },
    //到底提示
    finishedText: {
      type: String,
      default: dataListConfig.finishedText
    },
    //错误提示
    errorText: {
      type: String,
      default: dataListConfig.errorText
    },
    // 可选数据请求前回调
    onOptionsLoadBefore: {
      type: Function,
      default: null
    },
    // 可选数据请求后回调
    onOptionsLoadAfter: {
      type: Function,
      default: null
    },
    //是否可以刷新
    refresh: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      index: 0,
      list: [],
      show: true,
      isLoading: false,
      refreshLoading: false,
      loading: false,
      finished: false,
      error: false,
      tabActive: 0,
      pageIndex: 0,
      empty: false,
      param: {}
    };
  },
  watch: {
    params() {
      this.reload();
    },
    data() {
      this.load();
    }
  },
  computed: {},
  created() {
    let { data } = this;
    this.pageIndex = this.pageStartIndex;
    if (!this.autoLoad) {
      this.loading = false;
      this.finished = true;
    }
    if (data && data.length) {
      this.load();
    }
  },
  methods: {
    /**
     * @description: 重载
     * @param {*} function
     * @return {*}
     */
    reload: debounce(function() {
      this.list = [];
      this.empty = false;
      this.pageIndex = 0;
      this.finished = false;
      this.loading = true;
      this.refreshLoading = false;
      this.error = false;
      this.load();
    }, 100),
    /**
     * @description: 刷新已有数据
     * @param {*}
     * @return {*}
     */
    onRefresh() {
      this.empty = false;
      this.pageIndex = 0;
      this.finished = true;
      this.loading = false;
      this.error = false;
      this.load();
    },
    /**
     * @description: 加载
     * @param {*}
     * @return {*}
     */
    load() {
      let that = this;
      let { pageField, sizeField, pageIndex, api } = that;
      if (that.isLoading && pageIndex != 0) {
        return;
      }
      let base = {};
      base[pageField] = pageIndex;
      base[sizeField] = 10;
      console.log(pageIndex);
      if (api) {
        let {
          index,
          list,
          dataType,
          dataField,
          totalField,
          onOptionsLoadBefore
        } = that;
        let json = { ...base, ...that.params, ...that.param };
        let params = null;
        if (dataType == "formdata") {
          var formData = new FormData();
          for (var key in json) {
            formData.append(key, json[key]);
          }
          params = formData;
        } else {
          params = json;
        }

        //请求前
        if (onOptionsLoadBefore) {
          params = onOptionsLoadBefore(params);
          if (params === false) return;
        }

        that.isLoading = true;
        that.index = ++index;
        params[that.isLoadingKey] = false;
        api(params)
          .then(res => {
            if (that.index != index) {
              that.error = false;
              that.isLoading = false;
              return false;
            }
            let data = dataField ? findData(res, dataField) : res;
            //请求后
            if (that.onOptionsLoadAfter) {
              const callbackRes = that.onOptionsLoadAfter(res);
              if (callbackRes) {
                data = callbackRes;
              }
            }
            let pageIndex = json[pageField];
            if (data.length == 0 && that.pageStartIndex == pageIndex) {
              that.empty = true;
            } else {
              that.pageIndex = pageIndex + 1;
              if (pageIndex == 0) {
                that.list = data;
              } else {
                that.list = list.concat(data);
              }

              that.finished = that.list.length >= findData(res, totalField);
            }
            that.isLoading = false;
            that.loading = false;
            that.refreshLoading = false;
          })
          .catch(() => {
            that.isLoading = false;
            that.loading = false;
            that.error = true;
          });
      } else if (that.data && that.data.length) {
        that.empty = false;
        that.list = that.data;
        that.loading = false;
        that.finished = true;
      } else {
        that.empty = true;
      }
    },
    /**
     * @description: 删除
     * @param {*} index
     * @return {*}
     */
    deleteRow(index) {
      this.list.splice(index, 1);
    },
    /**
     * @description: 改变内容
     * @param {*} index
     * @param {*} callback
     * @return {*}
     */
    changeRow(index, callback) {
      this.list[index] = callback(this.list[index]);
    },
    /**
     * @description: 改变全部
     * @param {*} option
     * @return {*}
     */
    changeAll(option) {
      let list = this.list;
      for (var i in option) {
        list.map(p => (p[i] = option[i]));
      }
      this.list = list;
    },
    /**
     * @description: 列表 渲染
     * @param {*}
     * @return {*}
     */
    listRender() {
      if (this.empty) {
        return <noData />;
      } else if (this.show) {
        const {
          list,
          loading,
          load,
          finished,
          finishedText,
          error,
          errorText,
          $scopedSlots: slots
        } = this;
        const option = {
          props: {
            loading,
            finished,
            finishedText,
            error,
            errorText
          },
          on: {
            input: val => {
              if (this.loading != val && !this.isLoading) {
                this.loading = val;
              }
            },
            "update:error": val => {
              this.error = val;
            },
            load
          },
          class: "data-list"
        };
        return <van-list {...option}>{slots.default(list)}</van-list>;
      }
    }
  },
  render() {
    if (this.refresh) {
      const option = {
        props: {
          value: this.refreshLoading
        },
        on: {
          input: val => {
            this.refreshLoading = val;
          },
          refresh: this.onRefresh
        },
        style: {
          minHeight: "100%"
        }
      };
      return (
        <van-pull-refresh {...option}>{this.listRender()}</van-pull-refresh>
      );
    } else {
      return this.listRender();
    }
  }
};
</script>

<style lang="less" scoped>
.data-list {
  min-height: 100%;
}
</style>
